<template>
  <div
    id="app"
    class="app"
    :class="{ 'dark-app': ['Introduction', 'Detail'].includes($route.name) }"
  >
    <div class="landscape-container" v-if="!isPc">
      <div class="landscape-inner">
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/rotate-tip.png"
          alt=""
        />
      </div>
    </div>
    <audio
      id="music"
      src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/bgm01.mp3"
      loop
    ></audio>
    <router-view />

    <div
      v-if="['Welcome', 'Introduction', 'ThirteenCity'].includes($route.name)"
    >
      <img
        src="./new-new-assets/muted.svg"
        v-if="isMuted"
        alt=""
        class="music-icon"
        @click="changeToPlay"
      />
      <img
        src="./new-new-assets/play.svg"
        v-else
        alt=""
        class="music-icon"
        @click="changeToStop"
      />
    </div>

    <div class="no-show" style="display: none">
      <!-- 长图背景 -->
      <img
        src="https://jcdn.xhby.net/project/lianghui/new-assets/thirteen-city/bg.jpg"
      />

      <img src="./new-new-assets/bg.png" />
      <!-- 省委书记 -->
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/photo/suqian-louqinjian.png"
      />

      <img v-for="(s, i) in imgPreLoad" :key="i" :src="s" />

      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png"
      />
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-1.png"
      />
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-2.png"
      />
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-3.png"
      />

      <!-- 版权背景 -->
      <img
        src="https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/shallow.png"
      />
      <img src="https://jcdn.xhby.net/project/lianghui/new-assets/end/xu.jpg" />
    </div>
  </div>
</template>

<script>
import { areaInfoList } from "./data";
export default {
  data() {
    return {
      isPc: false,
      imgPreLoad: [],

      isMuted: false,
    };
  },
  watch: {
    isMuted() {
      window.isMuted = this.isMuted;
    },
  },
  mounted() {
    const hash = location.hash;
    const noNeedJump = hash === "#/" || hash.includes("two-phone-scan-code");
    if (!noNeedJump) {
      this.$router.replace("/");
    }

    this.isPc = this.$isPc();

    const where = this.$route.params.where;
    if (where) {
      const info = areaInfoList[where];
      info.wxMsg && this.$wx(info.wxTitle, info.wxMsg);
    } else {
      this.$wx();
    }

    document.addEventListener("visibilitychange", () => {
      // 用户息屏、或者切到后台运行 （离开页面）
      if (document.visibilityState === "hidden") {
        this.stopMusic();
      }

      // 用户打开或回到页面
      if (document.visibilityState === "visible") {
        if (this.$route.name !== "ViewVideo") {
          this.playMusic();
        }
      }
    });

    Object.keys(areaInfoList).forEach((name) => {
      const info = areaInfoList[name];
      this.imgPreLoad.push(info.leaderSign);
      this.imgPreLoad.push(info.word.left);
      this.imgPreLoad.push(info.word.right);
      this.imgPreLoad.push(info.detailImg);
      this.imgPreLoad.push(info.aloneImg);
    });
  },
  methods: {
    stopMusic() {
      const audio = document.getElementById("music");
      audio.pause();
    },

    playMusic() {
      if (this.isMuted) return;
      const audio = document.getElementById("music");
      audio.play();
    },

    changeToStop() {
      this.isMuted = true;
      this.stopMusic();
    },

    changeToPlay() {
      this.isMuted = false;
      this.playMusic();
    },
  },
  provide() {
    return {
      isPc: this.isPc,
    };
  },
};
</script>

<style>
@font-face {
  font-family: "FZZH";
  src: url("https://jcdn.xhby.net/project/wufengshan/store/assets/FZYANSJW_0.TTF");
}

#app {
  font-family: "黑体";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  max-width: 640px;
  margin: 0 auto;
  height: 100vh;
  overflow: hidden;
}

.app {
  background: url("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/bg.png");
  background-size: 101% 100%;
}

.dark-app {
  background: url("./new-new-assets/bg.png");
  background-size: 101% 100%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.logo-container {
  margin-top: 6vh !important;
}

.music-icon {
  position: absolute;
  left: 4vw;
  top: 6vh;
  width: 8vw;
  z-index: 999;
}

@media screen and (min-width: 640px) {
  .music-icon {
    position: absolute;
    left: calc(50vw - 320px + 20px);
    top: 6vh;
    width: 50px;
    z-index: 999;
  }
}
</style>


<style>
.landscape-container {
  width: 100vw;
  height: 100vh;
  background: url("https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/bg-rotate.png");
  background-size: 100% 100%;

  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 300;
  line-height: 32px;
}

.landscape-container .landscape-inner {
  width: 100%;
  height: 100%;
  color: white;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media screen and (orientation: portrait) {
  /* 竖着的 */
  .landscape-container {
    display: none;
  }

  .main-container {
    display: block;
  }
}

@media screen and (orientation: landscape) {
  /* 横着 */

  .landscape-container {
    display: block !important;
  }
}

audio {
  /* display: none; */
  visibility: hidden;
}

.no-show {
  display: none;
}
</style>